import React from 'react';
import { HStack, StackProps, useStyles } from '@chakra-ui/react';

export const CardRightActions: React.FC<StackProps> = (props) => {
  const { children, ...rest } = props;
  const styles = useStyles();

  return (
    <HStack sx={styles.rightActions} {...rest}>
      {children}
    </HStack>
  );
};
